import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { AppProviders } from "./app/providers/AppProviders";
import "./styles/index.css";

const initialUrl = new URL(window.location.href);
if (
  initialUrl.pathname === "/" &&
  (initialUrl.searchParams.has("code") ||
    initialUrl.searchParams.has("error") ||
    initialUrl.searchParams.has("error_description"))
) {
  window.history.replaceState(null, "", `/auth/callback${initialUrl.search}`);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
